import Vue from 'vue';
import axios from 'axios'
import router from '@/router.js'

export default {
    REGISTER(state, response) {
        let token = response.data.token;
        localStorage.setItem('token', token);
        localStorage.setItem('role', response.data.role);
        localStorage.setItem('lang', response.data.language);

        if (response.data.role === 'client')
            localStorage.removeItem('address');
        else
            localStorage.setItem('address', 'true');

        response.data.user.token = response.data.token;
        state.user = response.data.user;

        if(response.status == 200 && response.data.success == true) {
            router.push(`/client/appointments`);
        }

        axios.defaults.headers.common = {
            "Accept": "application/json",
            "Authorization" : 'Bearer '+token
        };
    },
    LOGIN(state, response) {
        let token = response.data.access_token ? response.data.access_token : response.data.token;
        localStorage.setItem('token', token);
        localStorage.setItem('role', response.data.role);

        response.data.user.adress = response.data.user.billing_details;

        if (response.data.role === 'client') {
            if (response.data.user.adress)
                localStorage.setItem('address', 'true');
        } else {
            localStorage.setItem('address', 'true');
        }

        state.user = response.data.user;
        state.user.token = response.data.access_token;
        state.user.role = response.data.role;
        state.services = response.data.services;

        if (state.user.role === 'client') {
            router.push(`/client/appointments`);
        } else {
            router.push(`/specialist/stats`);
        }

        axios.defaults.headers.common = {
            "Accept": "application/json",
            "Authorization" : 'Bearer '+token
        };
    },
    LOGIN_MEETING(state, response) {
        if(response.status == 200) state.user = response.data.user;
    },
    LOGIN_ANYTIME_MEETING(state, response) {
        if(response.status == 200) state.user = response.data.user;
    },
    LOGOUT() {
        var role = localStorage.getItem('role');
        localStorage.clear();
        sessionStorage.clear();
        /*
        if(role === 'specialist')
            router.push('/specialist/login')
        else 
            router.push('/login');
        */

        if (role === 'specialist')
            location.href = '/specialist/login';
        else
            location.href = '/login';
    },
    RESET_PASSWORD() {
        router.push(`/login`);
    },
    USER(state, response) {
        response.data.user.role = response.data.role;
        state.user = response.data.user;
        
        response.data.user.adress = response.data.user.billing_details;
        state.user.address = response.data.user.adress;
        
        if (state.user.role === 'client') {
            if (state.user.address)
                localStorage.setItem('address', 'true');
            else 
                localStorage.setItem('address', 'false');
        } else {
            localStorage.setItem('address', 'true');
        }

        if (response.data.user.hasOwnProperty('billing_details')) {
            state.user.address = response.data.user.billing_details;
        }

        if(response.data.role == 'client')
            state.services = response.data.services;
            
        if(response.data.role == 'client' && response.data.user.billing_details)
            if(router.history.current.fullPath == '/client/one-more-step'){
                router.push(`/client/appointments`);
            }
    },
    // TYPE 1: credit -> decrease amount from user balance
    // TYPE 2: debit -> increase amount to user balance
    // TYPE 3: replace -> replace amount
    UPDATE_BALANCE(state, data) {
        switch (data.type) {
            case 'credit': {
                state.user.balance += data.amount;
                break;
            }
            case 'debit': {
                state.user.balance -= data.amount;
                break;
            }
            case 'replace': {
                state.user.balance = data.amount;
                break;
            }
        }
    },
    // TYPE 1: push -> add services to object
    // TYPE 2: remove -> remove services to object
    // TYPE 3: replace -> replace services oobject
    UPDATE_SERVICES(state, data) {
        switch (data.type) {
            case 'push': {
                data.services.forEach(service => {
                    state.services.unshift(service);
                });
                break;
            }
            case 'remove': {
                state.services.forEach((userService, i) => {
                    data.services.forEach((service, j) => {
                        if(userService.id === service.id) {
                            state.services.splice(i, 1);
                        }
                    });
                });
                break;
            }
            case 'replace': {
                state.services = data.services;
                break;
            }
        }
    },
    UPDATE(state, data) {
        if(data.id) state.user.id = data.id;
        if(data.first_name) state.user.first_name = data.first_name;
        if(data.last_name) state.user.last_name = data.last_name;
        if(data.email) state.user.email = data.email;
        if(data.dob) state.user.dob = data.dob;
        if(data.token) state.user.token = data.token;
        if(data.role) state.user.role = data.role;
        if(data.balance) state.user.balance = data.token;
        
        // Specialist specific fields
        if(data.image_url) state.user.image_url = data.image_url;
        if(data.video_url) state.user.video_url = data.video_url;
        if(data.title) state.user.title = data.title;
        if(data.base_price) state.user.base_price = data.base_price;
        if(data.default) state.user.default = data.default;
        if(data.education) state.user.education = data.education;
        if(data.experience) state.user.experience = data.experience;
        if(data.about) state.user.about = data.about;
        if(data.timetable) state.user.timetable = data.timetable;
        
        if (data.hasOwnProperty('billingDetails')) state.user.address = data.billingDetails;
        
    }
}
